import fs from 'node:fs'
import path from 'node:path'

const SNAPSHOT_COMMENT = '# BetterStart: snapshot files are local-only; manifest is committed'
const SNAPSHOT_IGNORE = '.betterstart/'
const SNAPSHOT_ATTRIBUTES = '.betterstart/** text eol=lf'

function ensureLine(filePath: string, line: string, comment?: string): void {
  const existing = fs.existsSync(filePath) ? fs.readFileSync(filePath, 'utf-8') : ''
  const lines = existing === '' ? [] : existing.split('\n')

  if (lines.includes(line)) {
    return
  }

  const nextLines = [...lines.filter(Boolean)]
  if (comment && !nextLines.includes(comment)) {
    nextLines.push(comment)
  }
  nextLines.push(line)
  fs.writeFileSync(filePath, `${nextLines.join('\n')}\n`, 'utf-8')
}

export function ensureSnapshotGitignore(cwd: string): void {
  ensureLine(path.join(cwd, '.gitignore'), SNAPSHOT_IGNORE, SNAPSHOT_COMMENT)
}

export function ensureSnapshotGitattributes(cwd: string): void {
  ensureLine(path.join(cwd, '.gitattributes'), SNAPSHOT_ATTRIBUTES)
}

export function ensureSnapshotGitFiles(cwd: string): void {
  ensureSnapshotGitignore(cwd)
  ensureSnapshotGitattributes(cwd)
}
